import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { sanitizeLanguage, SUPPORTED_LANGS, LANG_STORAGE_KEY, setStoredLanguage } from '@/lib/i18n-safe';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';

i18n
  .use(initReactI18next)
  // LanguageDetector deliberately removed — language is controlled explicitly via
  // URL segment (public routes) or UserProfile.preferred_language (authenticated).
  // Auto-detection caused race conditions and bypassed the language whitelist.
  .init({
    resources: {
      en: { translation: enTranslations },
      fr: { translation: frTranslations }
    },
    lng: sanitizeLanguage(localStorage.getItem(LANG_STORAGE_KEY)),
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGS],
    interpolation: {
      escapeValue: false // React already escapes by default
    },
    missingKeyHandler: (_lngs, _ns, key) => {
      // Key name is rendered as fallback by i18next — UI is never blank.
      // Log to console in development for easy discovery during migration.
      if (import.meta.env.DEV) {
        console.warn(`[i18n] Missing translation key: ${key}`);
      }
    }
  });

i18n.on('languageChanged', (lng) => {
  const safe = sanitizeLanguage(lng);
  // Re-sanitize on every change — prevents unsupported langs entering the app
  if (safe !== lng) {
    i18n.changeLanguage(safe);
    return;
  }
  document.documentElement.lang = safe; // required for screen readers + SEO
  setStoredLanguage(safe);
});

export default i18n;
